module.exports = __webpack_public_path__ + "static/media/Sofia-Pro-Semi-Bold.b86d4e82.ttf";